// Horizontal indent per nesting level (px).
export const DEPTH_STEP = 24

// Horizontal padding of a table cell (px). A configured column width covers the content box only,
// so the padding has to be added on top of it when reasoning about the full column width.
export const CELL_PADDING_X = 12

// Left offset of an inline create-form on top of its nesting indent (px).
export const FORM_INDENT_OFFSET = 16

// Id of the tree's scroll container, so content inside it (the inline create-forms) can scroll it.
export const TREE_SCROLL_CONTAINER_ID = 'TableTreeScrollContainer'
